import { statusesForGlobal } from 'shared/helpers/constants/lots/statusesForGlobal';

const scanReceivedPackagesAccess = (auth, { statusForGlobal }) =>
  auth.access.lots.updateAsReceived &&
  [statusesForGlobal.not_received, statusesForGlobal.partly_received].includes(statusForGlobal);

export { scanReceivedPackagesAccess };
